import { Button } from '@/components/ui/button.tsx'

interface ServiceCardProps {
  buttonName: string
  link: string
  image: string
  title: string
  description: string
}

export const ServiceCard = ({
  buttonName,
  link,
  image,
  title,
  description,
}: ServiceCardProps) => {
  const handleButtonClick = () => {
    window.open(link, '_blank')
  }

  return (
    <div className="flex h-[456px] w-[616px] flex-col items-center justify-center gap-6 rounded-xl bg-card shadow-md max-md:w-full max-md:max-w-[616px]">
      <div className="flex flex-col items-center justify-center gap-3">
        <h2 className="text-3xl font-semibold text-title">{title}</h2>
        <div className="w-[460px] text-center text-base font-normal text-text-sub max-md:w-5/6 max-md:max-w-[460px]">
          {description}
        </div>
      </div>
      <div className="flex h-[192px] w-[192px] items-center justify-center rounded-lg bg-secondary-50">
        <img
          src={image}
          alt=""
          width="168px"
          height="168px"
        />
      </div>
      <Button
        onClick={handleButtonClick}
        variant="default"
        className="w-[314px] max-md:w-[250px]"
      >
        {buttonName}
      </Button>
    </div>
  )
}
